const player = (audio) => {

  const svgPlay = document.getElementById('svg-play');
  const svgPause = document.getElementById('svg-pause');
  const svgPlayDescr = document.getElementById('svg-play-descr');
  const svgPauseDescr = document.getElementById('svg-pause-descr');
  const btnPlay = document.getElementById('btn-play');
  const btnPlayDescr = document.getElementById('btn-play-descr');

//show play/pause button svg
  btnPlay.addEventListener('click', () => {
    svgPlay.classList.toggle('display-none');
    svgPause.classList.toggle('display-none');
  });
  btnPlayDescr.addEventListener('click', () => {
    svgPlayDescr.classList.toggle('display-none');
    svgPauseDescr.classList.toggle('display-none');
  });

  //Audioplayer & controls
  const audioPlayer = document.querySelector(".audio-player");
  //let arrAudio = birdsData.map((el) => el[0].audio)

  //const randomAudio = (arrAudio) => arrAudio[Math.floor(Math.random()*arrAudio.length)];

  audio.addEventListener(
    "loadeddata",
    () => {
      audioPlayer.querySelector(".timebar-time-info .length").textContent = getTimeCodeFromNum(
        audio.duration
      );
      audio.volume = .75;
    },
    false
  );

  //click on timeline to skip around
  const timeline = audioPlayer.querySelector(".timebar");
  timeline.addEventListener("click", e => {
  const timelineWidth = window.getComputedStyle(timeline).width;
  const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
  audio.currentTime = timeToSeek;
}, false);


  //click volume slider to change volume
  const volumeSlider = audioPlayer.querySelector(".controls .volume-slider");
    volumeSlider.addEventListener('click', e => {
    const sliderWidth = window.getComputedStyle(volumeSlider).width;
    const newVolume = e.offsetX / parseInt(sliderWidth);
    audio.volume = newVolume;
    audioPlayer.querySelector(".controls .volume-percentage").style.width = newVolume * 100 + '%';
  }, false)

  //check audio percentage and update time accordingly
  setInterval(() => {
    const progressBar = audioPlayer.querySelector(".timebar-bar");
    const timebarCircle = audioPlayer.querySelector(".timebar-circle");
    progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
    timebarCircle.style.left = audio.currentTime / audio.duration * 100 + "%";
    audioPlayer.querySelector(".timebar-time-info .current").textContent = getTimeCodeFromNum(audio.currentTime);

  }, 500);

  //toggle between playing and pausing on button click
  //const playBtn = audioPlayer.querySelector(".controls .toggle-play");
  btnPlay.addEventListener(
    "click",
    () => {
      if (audio.paused) {
       
      
        svgPlay.classList.add('display-none');
        svgPause.classList.remove('display-none');
        audio.play();
      } else {
  
        svgPlay.classList.remove('display-none');
        svgPause.classList.add('display-none');
        audio.pause();
      }
    },
    false
  );

  const soundPlayer = document.getElementById('sound-player');
  soundPlayer.addEventListener("click", () => {
    audio.muted = !audio.muted;
   
  });

  //turn 128 seconds into 2:08
  const getTimeCodeFromNum = (num) => {
    let seconds = parseInt(num);
    let minutes = parseInt(seconds / 60);
    seconds -= minutes * 60;
    const hours = parseInt(minutes / 60);
    minutes -= hours * 60;

    if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
    return `${String(hours).padStart(2, 0)}:${minutes}:${String(
      seconds % 60
    ).padStart(2, 0)}`;
  };

  let thumb = timebar.querySelector(".timebar-circle");

  thumb.onmousedown = function(event) {
    event.preventDefault(); // предотвратить запуск выделения (действие браузера)

    let shiftX = event.clientX - thumb.getBoundingClientRect().left;
    // shiftY здесь не нужен, слайдер двигается только по горизонтали

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);

    function onMouseMove(event) {
      let newLeft = event.clientX - shiftX - timebar.getBoundingClientRect().left;

      // курсор вышел из слайдера => оставить бегунок в его границах.
      if (newLeft < 0) {
        newLeft = 0;
      }
      let rightEdge = timebar.offsetWidth - thumb.offsetWidth;
      if (newLeft > rightEdge) {
        newLeft = rightEdge;
      }

      thumb.style.left = newLeft + 'px';
    }

    function onMouseUp() {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    }

  };

  thumb.ondragstart = function() {
    return false;

  };


};
export default player;